import { useState, useRef } from "react";
import { Upload, X, Image } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ImageUpload = ({ value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [mode, setMode] = useState("upload"); // upload | url
  const fileRef = useRef(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { alert("Only image files allowed"); return; }
    if (file.size > 5 * 1024 * 1024) { alert("Max 5MB"); return; }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post(`${API}/upload`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      const fullUrl = `${process.env.REACT_APP_BACKEND_URL}${res.data.url}`;
      onChange(fullUrl);
    } catch { alert("Upload failed"); }
    setUploading(false);
  };

  return (
    <div>
      <div className="flex items-center gap-2 mb-1.5">
        <label className="text-sm font-medium text-gray-700">Image</label>
        <div className="flex gap-1 ml-auto">
          <button type="button" onClick={() => setMode("upload")} className={`text-[10px] px-2 py-0.5 rounded-full ${mode === "upload" ? "bg-indigo text-white" : "text-gray-400 hover:text-gray-600"}`}>Upload</button>
          <button type="button" onClick={() => setMode("url")} className={`text-[10px] px-2 py-0.5 rounded-full ${mode === "url" ? "bg-indigo text-white" : "text-gray-400 hover:text-gray-600"}`}>URL</button>
        </div>
      </div>

      {value ? (
        <div className="relative rounded-xl overflow-hidden h-24 bg-gray-50 border border-gray-200">
          <img src={value} alt="Preview" className="w-full h-full object-cover" />
          <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 w-6 h-6 bg-black/50 rounded-full flex items-center justify-center text-white hover:bg-black/70">
            <X size={12} />
          </button>
        </div>
      ) : mode === "upload" ? (
        <div>
          <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={handleFileUpload} data-testid="image-file-input" />
          <Button type="button" variant="outline" onClick={() => fileRef.current?.click()} disabled={uploading} className="w-full rounded-xl border-dashed border-gray-300 text-gray-400 hover:text-indigo hover:border-indigo h-16" data-testid="image-upload-button">
            <Upload size={16} className="mr-2" />
            {uploading ? "Uploading..." : "Click to upload image (max 5MB)"}
          </Button>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <Image size={14} className="text-gray-400 shrink-0" />
          <Input placeholder="Paste image URL" value={value} onChange={(e) => onChange(e.target.value)} className="rounded-xl" data-testid="image-url-input" />
        </div>
      )}
    </div>
  );
};

export default ImageUpload;
